import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AnnualFinancialStatement =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AnnualFinancialStatement, _BaseData);

  function AnnualFinancialStatement() {
    _classCallCheck(this, AnnualFinancialStatement);

    return _possibleConstructorReturn(this, _getPrototypeOf(AnnualFinancialStatement).call(this, "AnnualFinancialStatement"));
  }

  _createClass(AnnualFinancialStatement, [{
    key: "GetPropertyHistory",
    value: function () {
      var _GetPropertyHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(propertyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertyHistory/").concat(propertyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetPropertyHistory(_x) {
        return _GetPropertyHistory.apply(this, arguments);
      }

      return GetPropertyHistory;
    }()
  }, {
    key: "GetReviewListByYear",
    value: function () {
      var _GetReviewListByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(year) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetReviewListByYear/").concat(year)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetReviewListByYear(_x2) {
        return _GetReviewListByYear.apply(this, arguments);
      }

      return GetReviewListByYear;
    }()
  }, {
    key: "GetReviewListByPropertyId",
    value: function () {
      var _GetReviewListByPropertyId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(propertyId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetReviewListByPropertyId/").concat(propertyId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetReviewListByPropertyId(_x3) {
        return _GetReviewListByPropertyId.apply(this, arguments);
      }

      return GetReviewListByPropertyId;
    }()
  }, {
    key: "GetByYear",
    value: function () {
      var _GetByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(year, propertyId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByYear/").concat(year, "/").concat(propertyId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetByYear(_x4, _x5) {
        return _GetByYear.apply(this, arguments);
      }

      return GetByYear;
    }()
  }, {
    key: "GetIdByYear",
    value: function () {
      var _GetIdByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(year, propertyId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetIdByYear/").concat(year, "/").concat(propertyId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetIdByYear(_x6, _x7) {
        return _GetIdByYear.apply(this, arguments);
      }

      return GetIdByYear;
    }()
  }, {
    key: "GetAmountsByAfsId",
    value: function () {
      var _GetAmountsByAfsId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(afsId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAmountsByAfsId/").concat(afsId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetAmountsByAfsId(_x8) {
        return _GetAmountsByAfsId.apply(this, arguments);
      }

      return GetAmountsByAfsId;
    }()
  }, {
    key: "UpdateAmounts",
    value: function () {
      var _UpdateAmounts = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(afsId, amounts) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateAmounts/").concat(afsId), amounts));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function UpdateAmounts(_x9, _x10) {
        return _UpdateAmounts.apply(this, arguments);
      }

      return UpdateAmounts;
    }()
  }, {
    key: "Certify",
    value: function () {
      var _Certify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(afsId, certificationId) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("/api/".concat(this._controller, "/Certify/").concat(afsId, "/").concat(certificationId)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function Certify(_x11, _x12) {
        return _Certify.apply(this, arguments);
      }

      return Certify;
    }()
  }, {
    key: "UnSubmit",
    value: function () {
      var _UnSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(afsId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.post("/api/".concat(this._controller, "/UnSubmit/").concat(afsId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function UnSubmit(_x13) {
        return _UnSubmit.apply(this, arguments);
      }

      return UnSubmit;
    }()
  }, {
    key: "UpdateStatus",
    value: function () {
      var _UpdateStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(afsId, statusId) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateStatus/").concat(afsId, "/").concat(statusId)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function UpdateStatus(_x14, _x15) {
        return _UpdateStatus.apply(this, arguments);
      }

      return UpdateStatus;
    }()
  }, {
    key: "SetExtensionId",
    value: function () {
      var _SetExtensionId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(afsId, extensionRequestId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.get("/api/".concat(this._controller, "/SetExtensionId/").concat(afsId, "/").concat(extensionRequestId)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function SetExtensionId(_x16, _x17) {
        return _SetExtensionId.apply(this, arguments);
      }

      return SetExtensionId;
    }()
  }]);

  return AnnualFinancialStatement;
}(BaseData);

export default new AnnualFinancialStatement();